export default __webpack_public_path__ + "static/bg-about-976d8edb99f60bfff6613be84c2deab6.jpg";